import CommonProcess from 'app/components/OrderPayment/Common/CommonProcess';
import React from 'react';

const RspPayment = () => {
  return <CommonProcess />;
};

export default RspPayment;
